import { render } from "./friends.vue?vue&type=template&id=2dea6eee"
import script from "./friends.vue?vue&type=script&lang=js"
export * from "./friends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__